import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Option } from 'src/pages/CaseDetails/interfaces/EmiSchedule.type';
import { Dayjs } from 'dayjs';
import { IAgent, IAgentData } from '../types';

const initialState: IAgentData = {
  agentData: [],
  agentNames: [],
  lastRefreshedTimeStampPerformance: '',
  tlNames: [],
  loading: false,
  filteredData: [],
  IAgentPerformance: [],
  IAgentPerformanceFilter: [],
  loadingAgentPerformance: false,
  lastRefreshedTimeStampInput: '',
  despositionSummary: [],
  loadingDespositionSummary: false,
  despositionSummaryFilter: [],
  emiBucketWiseSummary: [],
  loadingEmiBucketWiseSummary: false,
  emiBucketWiseSummaryFilter: []
};

const TeleSenseiSlice = createSlice({
  name: 'TeleSensei',
  initialState,
  reducers: {
    setApiResponse(state, action) {
      const { data, lastRefreshedTimeStamp, agentNames, tlNames } = action.payload;
      state.agentData = data;
      state.lastRefreshedTimeStampPerformance = lastRefreshedTimeStamp;
      state.agentNames = agentNames;
      state.tlNames = tlNames;
      state.filteredData = data;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setFilteredData(state, action) {
      state.filteredData = action.payload;
    },
    setAgentPerformance(state, action) {
      const { data, lastRefreshedTimeStamp } = action.payload;
      state.IAgentPerformance = data;
      state.lastRefreshedTimeStampInput = lastRefreshedTimeStamp;
    },
    setLoadingAgentPerformance(state, action) {
      state.loadingAgentPerformance = action.payload;
    },
    setAgentPerformanceFiltered(state, action) {
      state.IAgentPerformanceFilter = action.payload;
    },
    setDespositionSummaryFilter(state, action) {
      state.despositionSummaryFilter = action.payload;
    },
    setLoadingDespositionSummary(state, action) {
      state.loadingDespositionSummary = action.payload;
    },
    setDespositionSummary(state, action) {
      const { data } = action.payload;
      state.despositionSummary = data;
    },
    setEmiBucketWiseSummary(state, action) {
      state.emiBucketWiseSummary = action.payload;
    },
    setLoadingEmiBucketWiseSummary(state, action) {
      state.loadingEmiBucketWiseSummary = action.payload;
    },
    setEmiBucketWiseSummaryFilter(state, action) {
      state.emiBucketWiseSummaryFilter = action.payload;
    },
    updateRowWhenDRRChanged(state, action) {
      const { agentReferenceId, dueCycle, updatedResponse } = action.payload;

      const updateAgentDrrTarget = (agent: IAgent) => {
        if (agent.agentReferenceId === agentReferenceId && agent.dueCycle === dueCycle) {
          return {
            ...agent,
            drrTarget: {
              ...agent.drrTarget,
              percentage: updatedResponse.agentDailyTargetPercentage,
              emiValue: updatedResponse.agentDailyTargetEmi
            }
          };
        }
        return agent;
      };

      state.agentData = state.agentData.map(updateAgentDrrTarget);
      state.filteredData = state.filteredData.map(updateAgentDrrTarget);
    }
  }
});

export const {
  setLoading,
  setApiResponse,
  setFilteredData,
  setAgentPerformance,
  setLoadingAgentPerformance,
  setAgentPerformanceFiltered,
  setDespositionSummaryFilter,
  setLoadingDespositionSummary,
  setDespositionSummary,
  setEmiBucketWiseSummary,
  setEmiBucketWiseSummaryFilter,
  setLoadingEmiBucketWiseSummary,
  updateRowWhenDRRChanged
} = TeleSenseiSlice.actions;

export default TeleSenseiSlice.reducer;
